export function buildDownloadUrlString(locale: string, slug: string) {
  return `/${locale.toLocaleLowerCase()}/download/${slug}/`;
}
